/** Deterministic dev collision grid for the characters showcase (pure; unit-tested). */
export const GRID_W = 40, GRID_H = 22;

/** Deterministic dev collision grid: border walls, a long wall with two gaps, crate clusters, pillars. */
export function buildShowcaseGrid(w = GRID_W, h = GRID_H): Uint8Array {
  const g = new Uint8Array(w * h);
  const set = (x: number, y: number, v = 1) => { if (x >= 0 && y >= 0 && x < w && y < h) g[y * w + x] = v; };
  for (let x = 0; x < w; x++) { set(x, 0); set(x, h - 1); }
  for (let y = 0; y < h; y++) { set(0, y); set(w - 1, y); }
  for (let y = 3; y < h - 3; y++) if (y !== 8 && y !== 15) set(14, y);          // long wall, gaps at rows 8 and 15
  for (let x = 20; x < 26; x++) for (let y = 4; y < 6; y++) set(x, y);           // crate row
  for (let x = 28; x < 31; x++) for (let y = 10; y < 13; y++) set(x, y);         // crate block
  for (const [x, y] of [[6, 10], [9, 13], [19, 12], [24, 16], [33, 6], [34, 17], [4, 17]] as const) set(x, y); // pillars
  for (let x = 18; x < 36; x++) set(x, 19);                                       // pier edge
  return g;
}

